export default 'Cookies | Solution Éco France';
